module.exports = __webpack_public_path__ + "static/img/IMG_20151229_114954-ANIMATION.3e27c2e2.gif";